export default __webpack_public_path__ + "static/media/04_Doorslag_2-nieuwe situatie.c7e2bb5e.jpg";